module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cell"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v(_vm._s(_vm.leftText))]), _vm._v(" "), _c('img', {
    staticClass: "img",
    attrs: {
      "src": _vm.imgUrl
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "middle"
  }, [_vm._v(_vm._s(_vm.middleText))]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._v(_vm._s(_vm.rightText))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2ce33ec3!./~/vue-loader/lib/selector.js?type=template&index=0!./src/comps/item-statics-dish.vue
// module id = 835
// module chunks = 34